var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { IsDateString, IsInt, IsOptional, Max, Min } from 'class-validator';
export class SchedulingConstraintsDto {
    latestStartDate;
    latestEndDate;
    minWeeklySlotCount;
    maxWeeklySlotCount;
}
__decorate([
    IsDateString(),
    IsOptional(),
    __metadata("design:type", String)
], SchedulingConstraintsDto.prototype, "latestStartDate", void 0);
__decorate([
    IsDateString(),
    IsOptional(),
    __metadata("design:type", String)
], SchedulingConstraintsDto.prototype, "latestEndDate", void 0);
__decorate([
    IsInt(),
    Min(1),
    Max(3),
    IsOptional(),
    __metadata("design:type", Number)
], SchedulingConstraintsDto.prototype, "minWeeklySlotCount", void 0);
__decorate([
    IsInt(),
    Min(1),
    Max(3),
    IsOptional(),
    __metadata("design:type", Number)
], SchedulingConstraintsDto.prototype, "maxWeeklySlotCount", void 0);
//# sourceMappingURL=scheduling-constraints.dto.js.map